module.exports = __webpack_public_path__ + "static/media/disease.888fa9ee.svg";